var r={contentWrapper:"contentWrapper__hQPKl3",iconWrapper:"iconWrapper__jCdEsD"};export{r as default};
